"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-valentino-torio": {
    "36389f15": [{
      "hkey": "9e475a15",
      "slug": "san-valentino-torio",
      "name": "San Valentino Torio",
      "primary": true,
      "skipSearch": false
    }],
    "casatori": [{
      "hkey": "9e475a15",
      "slug": "san-valentino-torio",
      "name": "San Valentino Torio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55c9d1b2": [{
      "hkey": "9e475a15",
      "slug": "san-valentino-torio",
      "name": "San Valentino Torio",
      "primary": true,
      "skipSearch": false
    }],
    "sciulia": [{
      "hkey": "9e475a15",
      "slug": "san-valentino-torio",
      "name": "San Valentino Torio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;